<script>
    import { push } from "svelte-spa-router";
    import { onMount } from "svelte/internal";
    import SimpleBackNav from "../components/donorflow-ui/SimpleBackNav.svelte";

    let name, portalId, db, isError;

    let doc = {
        layout: {
            sections: [
                {
                    rows: [
                        {
                            cols: [
                                {
                                    blocks: [
                                        {
                                            contentType: "text",
                                            content:
                                                "Start editing text here...",
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        createdAt: Date.now()
    };

    function save() {
        if(!name) { 
            isError = true;
            return;
        }
        db.collection("pages")
            .add({
                name,
                portalId,
                ...doc
            })
            .then((r) => {
                push("/page/" + r.id);
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onMount(() => {
        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
        }
        portalId = localStorage.getItem("portal");
        db = firebase.firestore();
    });
</script>

<SimpleBackNav to="/" />
<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-4">
            <div style="height:80px;" />
            <div class="card shadow">
                <div class="card-body">
                    <div style="height: 20px;" />
                    {#if isError}
                        <div class="alert alert-warning">
                            * Name is required.
                        </div>
                    {/if}
                    <label style="font-weight:bold;font-size:1.1rem;">😃 Give your page a name</label>
                    <div style="height: 10px;" />
                    <input type="text" class="form-control" bind:value={name} />
                    <div style="height: 40px;" />
                    <div class="text-center">
                        <button class="btn btn-dark" on:click={save}
                        >Continue 👉</button
                    >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
